import { render, staticRenderFns } from "./PrimaryImageOnlyBaseCta.vue?vue&type=template&id=a03aa15e&scoped=true&"
import script from "./PrimaryImageOnlyBaseCta.vue?vue&type=script&lang=js&"
export * from "./PrimaryImageOnlyBaseCta.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryImageOnlyBaseCta.vue?vue&type=style&index=0&id=a03aa15e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03aa15e",
  null
  
)

export default component.exports